module.exports = __webpack_public_path__ + "docs/CommunityGuidelines.6e3d53ae90c3da3290b82306613314da.html";